export default __webpack_public_path__ + "static/media/WD-420 cash drawer.00fa8257.jpg";